// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1v2MH","question":"styles_question__25P8G","description":"styles_description__8sE0o"};